/* eslint-disable no-console */
import { FC, useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import Table from 'components/common/Table/Table';
import { pageAlertConfigState } from 'components/common/PageAlert/PageAlert.state';
import { PageAlertVariant } from 'components/common/PageAlert/PageAlert.types';
import { useRecoilValue } from 'recoil';
import { SIZE } from 'common/constants';
import ELEMENT from 'common/element';
import { Permission, Secret } from 'common/graphqlTypes';
import { hasPermissionState } from 'components/account/account.state';
import { HEADERS } from '../consts';
import { makeSecretRowData } from '../helpers';
import { RowObject, SecretAndDeselect, SecretData } from '../types';

import EditSecretDialog from '../Dialogs/EditSecretDialog';
import DeleteSecretDialog from '../Dialogs/DeleteSecretDialog';

type SecretsTableProps = {
  data?: SecretData;
};

const SecretsTable: FC<SecretsTableProps> = ({ data }) => {
  const [selectedSecret, setSelectedSecret] = useState<Secret>();
  const setPageAlertConfig = useSetRecoilState(pageAlertConfigState);

  const deselectSecret: SecretAndDeselect['deselectSecret'] = () => {
    setSelectedSecret(undefined);
  };
  const [editSecretDialogIsOpen, setEditSecretDialogIsOpen] = useState(false);
  const [deleteSecretDialogIsOpen, setDeleteSecretDialogIsOpen] = useState(false);
  const showAlert = (message: string): void => {
    setPageAlertConfig({ message, variant: PageAlertVariant.SUCCESS, autoHide: true });
  };

  const doModifySecret = (secret: Secret): void => {
    setSelectedSecret(secret);
    setEditSecretDialogIsOpen(true);
  };

  const doDeleteSecret = (secret: Secret): void => {
    setSelectedSecret(secret);
    setDeleteSecretDialogIsOpen(true);
  };

  const handleChange = (): void => {
    setSelectedSecret(undefined);
  };

  const hasFullAccessPermission = useRecoilValue(hasPermissionState(Permission.fullAccess));
  const [tableData, setTableData] = useState<RowObject[]>([]);
  useEffect((): void => {
    if (data) {
      setTableData(
        data.secrets.map((secret: Secret) =>
          makeSecretRowData({
            secret,
            showAlert,
            isWriteDisabled: !hasFullAccessPermission,
            doModifySecret,
            doDeleteSecret,
          }),
        ),
      );
    }
  }, [data]);

  const tableOptions = {
    isStriped: false,
    isSortable: false,
    hoverRow: true,
    sidePadding: 10,
    size: SIZE.MEDIUM,
  };
  return (
    <>
      <Table headers={HEADERS} data={tableData} options={tableOptions} testIdRow={ELEMENT.secretsTableRow} />
      <EditSecretDialog
        handleChange={handleChange}
        selectedSecret={selectedSecret}
        deselectSecret={deselectSecret}
        editSecretDialogIsOpen={editSecretDialogIsOpen}
        setEditSecretDialogIsOpen={setEditSecretDialogIsOpen}
      />
      <DeleteSecretDialog
        handleChange={handleChange}
        selectedSecret={selectedSecret}
        deselectSecret={deselectSecret}
        deleteSecretDialogIsOpen={deleteSecretDialogIsOpen}
        setDeleteSecretDialogIsOpen={setDeleteSecretDialogIsOpen}
      />
    </>
  );
};

export default SecretsTable;
